import { render, staticRenderFns } from "./OrderTaskList.vue?vue&type=template&id=60422c64&scoped=true"
import script from "./OrderTaskList.vue?vue&type=script&lang=js"
export * from "./OrderTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60422c64",
  null
  
)

export default component.exports